;(function() {
function SigniService($location, $window, ModalConfirmFactory, ModalInfo, CompletedOrderService) {

    let orderService = CompletedOrderService;

    return {
        handleSigniResponse
    };

    function handleSigniResponse() {
        if (showModalIfSuccess()) {
            ModalInfo("signi.success.title", "signi.success.desc", "signi.success.btn")
                .add()
                .result
                .then();
        } else {
            orderService.haveAccessToSigni().then(haveAccess => {
                if (haveAccess) {
                    showSigniModal();
                }
            });
        }
    }

    function showModalIfSuccess() {
        const res = $location.search();
        return res.signi === "success"
    }

    function showSigniModal() {
        ModalConfirmFactory("signi.title", "signi.desc", "signi.confirm", "signi.cancel")
            .add()
            .result.then(result => {
            if (result === "confirm") {
                window.showSpinner(1);
                orderService.createSigniDocument().then(link => {
                    $window.location = link;
                });
            }
        });
    }
}

angular.module("firmaren")
    .service("SigniService", SigniService);
}());
